import React from 'react';

import '@app/scss/pages/aboutUs.scss';
import NewContactForm from '@app/components/UI/ContactForm/NewContactForm';
import ElementWithIntersectionObserver
	from '@app/components/UI/components/ElementWithIntersectionObserver/ElementWithIntersectionObserver';
import Articles from '@app/components/Pages/AboutUs/ArticleList';
import SimpleScroll from '@app/components/UI/SimpleScroll/SimpleScroll';

const articles = [
	{
		title: '#1',
		subtitle: 'DMV TAG AGENCY',
		text: 'Our Tag Agency offers comprehensive auto title and registration services with exceptional client service for customers and auto' +
			' dealers in all 50 states. Enjoy smooth transactions, instant fee estimates, vehicle lookups, NMVTIS and more on our user-friendly' +
			' platform for a hassle-free experience.'
	},
	{
		title: '30',
		subtitle: 'YEARS OF EXPERIENCE',
		text: 'With 30 years of expertise in delivering title and registration services, our dedicated professionals ensure a seamless and' +
			' stress-free experience for all customers. Whatever your needs, count on us for reliable solutions!'
	},
	{
		title: '50',
		subtitle: 'STATE DMV',
		text: 'Our expert team is ready to assist with your transaction needs in all 50 states, offering services designed to streamline your DMV' +
			' experience and minimize stress. Reach out today to discover how we can facilitate your process!'
	}
];

const AboutUs: React.FC = () => {
	return (
		<div className="about-us">
			<div className="about-us__section container" style={{minHeight: '100vh'}}>
				<div className="perspective">
					<h1 className="contact-us__title hero-text hero">
						<span className="clipped">About</span> us
					</h1>
				</div>
				<div className="perspective">
					<h4 className="fade-in-slow-on-view">
						We expedite title and registration transactions for dealers and customers in the United States, ensuring a swift, accurate,
						and compliant process. Our skilled team facilitates a hassle-free experience, helping clients complete their transactions
						efficiently and correctly.
					</h4>
				</div>
				<SimpleScroll/>
			</div>
			<div className="container">
				<ElementWithIntersectionObserver
					inner={showed =>
						<div className={`w-layout-grid grid-about-images ${showed ? 'image-animations' : ''}`}>
							<div className="image-holder _1">
								<div className="white-bg-over-image"/>
								<picture>
									<source media="(max-width: 500px)" srcSet="/images/IMG_0238-p-500.jpg"/>
									<source media="(min-width: 800px)" srcSet="/images/IMG_0238-p-800.jpg"/>
									<source media="(min-width: 1080px)" srcSet="/images/IMG_0238-p-1080.webp"/>
									<img className="image-100pct" alt="DMV" aria-hidden="true" src="/images/IMG_0238.webp"/>
								</picture>
							</div>
							<div className="image-holder _2">
								<picture>
									<source media="(max-width: 500px)" srcSet="/images/black-car-p-500.jpg"/>
									<source media="(min-width: 800px)" srcSet="/images/black-car-p-800.jpg"/>
									<source media="(min-width: 1080px)" srcSet="/images/black-car-p-1080.jpg"/>
									<img className="image-100pct" alt="black car" aria-hidden="true" src="/images/black-car-p-1600.jpg"/>
								</picture>
								<div className="white-bg-over-image"/>
							</div>
							<div className="image-holder _3">
								<picture>
									<source media="(max-width: 500px)" srcSet="/images/tim-meyer-WvA85uSNL6k-unsplash-min-p-500.jpg"/>
									<source media="(min-width: 800px)" srcSet="/images/tim-meyer-WvA85uSNL6k-unsplash-min-p-800.jpg"/>
									<source media="(min-width: 1080px)" srcSet="/images/tim-meyer-WvA85uSNL6k-unsplash-min-p-1080.jpg"/>
									<img className="image-100pct" alt="grey car" aria-hidden="true" src="/images/tim-meyer-WvA85uSNL6k-unsplash-min-p-1600.jpg"/>
								</picture>
								<div className="white-bg-over-image"/>
							</div>
						</div>
				}/>
			</div>
			<div className="container" style={{position: 'relative', zIndex: 2}}>
				<Articles articles={articles}/>
			</div>
			<NewContactForm title="How can we help?"/>
		</div>
	);
};

export default AboutUs;
